import { type Ati } from '@atlassian/ari';

import type { MenuItem, MixedMenuItems, SimpleMenuItems, UniversalCreateItems } from './types';

export function isSimpleMenuItems(items: UniversalCreateItems): items is SimpleMenuItems {
	if (Array.isArray(items)) {
		return items.every((item) => {
			return typeof item === 'object' && item !== null && 'ati' in item;
		});
	}

	return false;
}

export function useNormalizeItems(items: UniversalCreateItems): MixedMenuItems {
	const mixedItems: MixedMenuItems = [];
	if (isSimpleMenuItems(items)) {
		mixedItems.push({
			items,
		});
	} else {
		mixedItems.push(...items);
	}

	return mixedItems;
}

export function findSelectedItem(items: MixedMenuItems, selectedItem: Ati): MenuItem | null {
	for (const namedItem of items) {
		for (const menuItem of namedItem.items) {
			if (menuItem.ati.toString() === selectedItem.toString()) {
				return menuItem;
			}
		}
	}
	return null;
}

/**
 * Extracts all ATIs from the mixed menu items
 * @param mixedItems - The mixed menu items to extract ATIs from
 * @returns Array of ATI strings
 */
export function extractNativeAtis(mixedItems: MixedMenuItems): string[] {
	return mixedItems
		.flatMap((namedItem) => namedItem.items)
		.map((menuItem) => menuItem.ati.toString());
}
